// extracted by mini-css-extract-plugin
export var container = "_87-0";
export var icon = "_87-1";
export var text = "_87-2";